// before 20-5-2026


// import React, { useEffect, useState } from 'react';
// import { Container } from 'react-bootstrap';
// import { Link, useParams } from 'react-router-dom';
// import {
//   KeyboardDoubleArrowRight,
//   Done,
//   CloudUpload,
//   Person,
//   Email,
//   Phone,
//   Badge,
//   Campaign,
//   Comment,
//   CheckCircle,
//   ExpandMore,
//   ExpandLess,
//   Numbers,
// } from '@mui/icons-material';
// import {
//   useTheme,
//   Avatar,
//   Button,
//   CircularProgress,
//   FormControl,
//   IconButton,
//   InputLabel,
//   MenuItem,
//   Select,
//   TextField,
//   Chip,
//   Box,
//   Paper,
//   Typography,
//   Switch,
//   Card,
//   CardContent,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   Slider,
//   InputAdornment,
// } from '@mui/material';
// import { useDispatch, useSelector } from 'react-redux';
// import { Get_One_user_data, Update_One_user_Main_data_Action } from '../Redux/Actions/AuthAction';
// import { Notify } from '../Utility/Notify';
// import { GetAllchannalData } from '../Redux/Actions/ChannalActions';
// import CloseIcon from '@mui/icons-material/Close';

// const roledata = [
//   { id: 1, name: 'Admin', icon: '👨‍💼' },
//   { id: 2, name: 'Manager', icon: '👔' },
//   { id: 3, name: 'Sales', icon: '💰' },
//   { id: 4, name: 'Team Leader', icon: '👥' },
//   { id: 5, name: 'Marketer', icon: '📢' },
//   { id: 6, name: 'Accountant', icon: '📊' },
// ];

// export const EditUserData = () => {
//   const { id } = useParams();
//   const dispatch = useDispatch();
//   const theme = useTheme();
//   const mode = theme.palette.mode;

//   // States
//   const [Role, setRole] = useState('');
//   const [name, setname] = useState('');
//   const [email, setemail] = useState('');
//   const [phone, setphone] = useState('');
//   const [image, SetImage] = useState('');
//   const [userData, setUserData] = useState([]);
//   const [loading, setloading] = useState(true);
//   const [updateLoading, setUpdateLoading] = useState(false);
//   const [opencommentschecked, setopencommentsChecked] = useState(false);
//   const [CloseDoneDealcommentschecked, setCloseDoneDealcommentsChecked] = useState(false);
//   const [selectedfile, setselecetedfile] = useState('');
//   const [requestedLeadsLimit, setRequestedLeadsLimit] = useState(100);

//   // Channels states
//   const [selectedChannels, setSelectedChannels] = useState([]);
//   const [channels, setChannels] = useState([]);
//   const [channelsLoading, setChannelsLoading] = useState(false);
//   const [expanded, setExpanded] = useState(false);

//   // Handlers
//   const handleNameChange = (e) => setname(e.target.value);
//   const handleEmailChange = (e) => setemail(e.target.value);
//   const handlePhoneChange = (e) => setphone(e.target.value);
  
//   const handleRequestedLeadsLimitChange = (e) => {
//     const value = parseInt(e.target.value);
//     if (!isNaN(value) && value >= 0) {
//       setRequestedLeadsLimit(value);
//     }
//   };

//   const onRoleChange = (e) => {
//     const newRole = e.target.value;
//     setRole(newRole);

//     if (
//       (Role === 'Marketer' && newRole !== 'Marketer') ||
//       (Role !== 'Marketer' && newRole === 'Marketer')
//     ) {
//       setSelectedChannels([]);
//     }

//     if (newRole === 'Marketer' && channels.length === 0) {
//       fetchChannels();
//     }
//   };

//   // Fetch channels
//   const fetchChannels = async () => {
//     setChannelsLoading(true);
//     await dispatch(GetAllchannalData());
//     setChannelsLoading(false);
//   };

//   // Handle channel selection
//   const handleChannelChange = (event) => {
//     const value = event.target.value;
//     setSelectedChannels(typeof value === 'string' ? value.split(',') : value);
//   };

//   const removeChannel = (channelToRemove) => {
//     setSelectedChannels(selectedChannels.filter((channel) => channel !== channelToRemove));
//   };

//   // Get channels from Redux
//   const resgetallchannal = useSelector((state) => state.AllChannalRoot?.channal);

//   // Fetch user data
//   useEffect(() => {
//     const fetchUserData = async () => {
//       await dispatch(Get_One_user_data(id));
//     };
//     fetchUserData();
//   }, [dispatch, id]);

//   const resUserData = useSelector((state) => state.AuthRoot.get_one_user_array);

//   // ✅ جلب بيانات المستخدم وعرضها
//   useEffect(() => {
//     if (resUserData?.data) {
//       const user = resUserData.data;
//       setUserData(user);

//       setname(user.name || '');
//       setemail(user.email || '');
//       setphone(user.phone || '');
//       setRole(user.role || '');
//       SetImage(user.profileImg || '');
//       setopencommentsChecked(user.opencomments === true || user.opencomments === 'true');
//       setCloseDoneDealcommentsChecked(user.CloseDoneDealcomments === true || user.CloseDoneDealcomments === 'true');
      
//       // ✅ أهم حاجة: جلب requestedleadslimit
//       const limit = user.requestedleadslimit !== undefined ? user.requestedleadslimit : 100;
//       setRequestedLeadsLimit(limit);
//       console.log('📥 Fetched requestedleadslimit:', limit);

//       // Set channels if user is Marketer
//       if (user.role === 'Marketer' && user.channels) {
//         const channelIds = user.channels.map((ch) => ch._id || ch);
//         setSelectedChannels(channelIds);
//       }

//       // Fetch channels if user is Marketer
//       if (user.role === 'Marketer') {
//         fetchChannels();
//       }
//     } else {
//       setUserData([]);
//     }
//   }, [resUserData]);

//   useEffect(() => {
//     if (resgetallchannal?.data) {
//       setChannels(resgetallchannal.data);
//     }
//   }, [resgetallchannal]);

//   // Switch handlers
//   const handleChange = (event) => setopencommentsChecked(event.target.checked);
//   const handleChangeCloseDoneDealComments = (event) =>
//     setCloseDoneDealcommentsChecked(event.target.checked);

//   // Image handler
//   const handleImageChange = (e) => {
//     if (e.target.files && e.target.files[0]) {
//       const file = e.target.files[0];
//       SetImage(URL.createObjectURL(file));
//       setselecetedfile(file);
//     }
//   };

//   // Convert URL to File
//   const convertURLtoFile = async (url) => {
//     try {
//       const response = await fetch(url, { mode: 'cors' });
//       const data = await response.blob();
//       const ext = url.split('.').pop();
//       return new File([data], `image-${Date.now()}.${ext}`, { type: `image/${ext}` });
//     } catch (error) {
//       console.error('Error converting URL to File:', error);
//       return null;
//     }
//   };

//   // ✅ Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (name === '') {
//       Notify('error', 'Name is Required', 'error');
//       return;
//     }
//     if (email === '') {
//       Notify('error', 'Email is Required', 'error');
//       return;
//     }
//     if (phone === '') {
//       Notify('error', 'Phone is Required', 'error');
//       return;
//     }
//     if (Role === '') {
//       Notify('error', 'Role is Required', 'error');
//       return;
//     }

//     setloading(true);
//     setUpdateLoading(true);

//     // ✅ استخدام JSON بدل FormData عشان أسهل
//     const userDataToSend = {
//       name: name,
//       email: email,
//       phone: phone,
//       role: Role,
//       opencomments: opencommentschecked,
//       CloseDoneDealcomments: CloseDoneDealcommentschecked,
//       requestedleadslimit: requestedLeadsLimit,
//     };

//     // Add channels if role is Marketer
//     if (Role === 'Marketer' && selectedChannels.length > 0) {
//       userDataToSend.channels = selectedChannels;
//     }

//     console.log('📤 Sending user data:', userDataToSend);
//     console.log('📤 requestedleadslimit being sent:', requestedLeadsLimit);

//     await dispatch(Update_One_user_Main_data_Action(id, userDataToSend));
//     setloading(false);
//     setUpdateLoading(false);
//   };

//   const resuserupdated = useSelector((state) => state.AuthRoot.oneuser);

//   useEffect(() => {
//     if (loading === false) {
//       if (resuserupdated && resuserupdated.status === 200) {
//         Notify('success', 'Updated Successfully', 'success');
//         setTimeout(() => {
//           window.location.href = '#/Users';
//         }, 1500);
//       }
//     }
//   }, [loading, resuserupdated]);

//   // Get role color
//   const getRoleColor = (role) => {
//     const colors = {
//       Admin: '#f44336',
//       Manager: '#2196f3',
//       Sales: '#4caf50',
//       'Team Leader': '#ff9800',
//       Marketer: '#9c27b0',
//       Accountant: '#607d8b',
//     };
//     return colors[role] || '#757575';
//   };

//   const isSpecialRole = () => {
//     return Role === 'Sales' || Role === 'Team Leader' || Role === 'Manager';
//   };

//   const isAdminOrMarketer = () => {
//     return Role === 'Admin' || Role === 'Marketer';
//   };

//   const getOpenCommentsLabel = () => {
//     if (isSpecialRole()) {
//       return {
//         title: 'Close Follow Up and Follow After Meeting',
//         description: 'Allow user to see and manage Follow Up and Follow After Meeting stages on leads'
//       };
//     } else if (isAdminOrMarketer()) {
//       return {
//         title: 'Close Meeting, Follow After Meeting and Interested (Stages)',
//         description: 'Allow user to see and manage Close Meeting, Follow After Meeting and Interested stages on leads'
//       };
//     } else {
//       return {
//         title: 'Open Comments',
//         description: 'Allow user to post comments on open deals'
//       };
//     }
//   };

//   const openCommentsLabel = getOpenCommentsLabel();

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         bgcolor: mode === 'dark' ? '#121212' : '#f5f5f5',
//         py: 3,
//       }}
//     >
//       <Container maxWidth="md" className="startpage">
//         {/* Breadcrumb */}
//         <Box sx={{ mb: 4 }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <Link to={`/AllLeadsForAdmin`} style={{ textDecoration: 'none' }}>
//               <Typography
//                 component="span"
//                 sx={{
//                   fontWeight: 'bold',
//                   color: '#102dff',
//                   '&:hover': { color: '#0d25cc' },
//                 }}
//               >
//                 Home
//               </Typography>
//             </Link>
//             <KeyboardDoubleArrowRight sx={{ fontSize: 16, color: '#666' }} />
//             <Link to={`/Users`} style={{ textDecoration: 'none' }}>
//               <Typography component="span" sx={{ color: '#666' }}>
//                 Users
//               </Typography>
//             </Link>
//             <KeyboardDoubleArrowRight sx={{ fontSize: 16, color: '#666' }} />
//             <Typography component="span" sx={{ color: '#666' }}>
//               Edit User
//             </Typography>
//           </Box>
//         </Box>

//         {/* Main Form Card */}
//         <Paper
//           elevation={mode === 'dark' ? 3 : 1}
//           sx={{
//             p: { xs: 3, md: 4 },
//             borderRadius: 4,
//             backgroundColor: mode === 'dark' ? '#1e1e1e' : '#fff',
//             boxShadow: mode === 'dark' ? '0 8px 32px rgba(0,0,0,0.3)' : '0 4px 20px rgba(0,0,0,0.08)',
//           }}
//         >
//           {/* Header */}
//           <Box sx={{ textAlign: 'center', mb: 4 }}>
//             <Typography
//               variant="h4"
//               sx={{
//                 fontWeight: 'bold',
//                 color: mode === 'dark' ? '#fff' : '#333',
//                 mb: 1,
//               }}
//             >
//               Edit User Profile
//             </Typography>
//             <Typography variant="body1" sx={{ color: mode === 'dark' ? '#aaa' : '#666' }}>
//               Update user information and permissions
//             </Typography>
//           </Box>

//           {/* Profile Image Upload */}
//           <Paper
//             elevation={mode === 'dark' ? 2 : 0}
//             sx={{
//               p: 3,
//               mb: 4,
//               borderRadius: 3,
//               backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fff',
//               border: `2px dashed ${mode === 'dark' ? '#444' : '#ddd'}`,
//               textAlign: 'center',
//             }}
//           >
//             <input
//               accept="image/*"
//               style={{ display: 'none' }}
//               id="avatar-upload"
//               type="file"
//               onChange={handleImageChange}
//             />

//             <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
//               <label htmlFor="avatar-upload">
//                 <IconButton component="span">
//                   <Avatar
//                     alt={userData?.name || 'User'}
//                     src={image}
//                     sx={{
//                       width: 100,
//                       height: 100,
//                       border: `3px solid ${getRoleColor(Role)}`,
//                       cursor: 'pointer',
//                       '&:hover': {
//                         transform: 'scale(1.05)',
//                         transition: 'transform 0.3s ease',
//                       },
//                     }}
//                   />
//                 </IconButton>
//               </label>

//               <Box>
//                 <Typography variant="h6" sx={{ color: mode === 'dark' ? '#fff' : '#333', mb: 1 }}>
//                   {image ? '✅ Profile Picture Selected' : 'Upload Profile Picture'}
//                 </Typography>
//                 <Typography
//                   variant="body2"
//                   sx={{ color: mode === 'dark' ? '#aaa' : '#666', mb: 2 }}
//                 >
//                   {image ? 'Click to change image' : 'Click on the avatar to upload'}
//                 </Typography>

//                 <Button
//                   component="label"
//                   variant="outlined"
//                   startIcon={<CloudUpload />}
//                   sx={{
//                     textTransform: 'none',
//                     borderRadius: 2,
//                   }}
//                 >
//                   Choose File
//                   <input type="file" hidden accept="image/*" onChange={handleImageChange} />
//                 </Button>
//               </Box>
//             </Box>
//           </Paper>

//           {/* Form */}
//           <form onSubmit={handleSubmit}>
//             {/* Personal Information */}
//             <Card sx={{ mb: 3, borderRadius: 3 }}>
//               <CardContent>
//                 <Typography
//                   variant="h6"
//                   sx={{
//                     mb: 3,
//                     color: mode === 'dark' ? '#fff' : '#333',
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: 1,
//                   }}
//                 >
//                   <Person sx={{ color: '#102dff' }} />
//                   Personal Information
//                 </Typography>

//                 <TextField
//                   fullWidth
//                   label="Full Name"
//                   value={name}
//                   onChange={handleNameChange}
//                   InputProps={{
//                     startAdornment: <Person sx={{ mr: 1, color: 'action.active' }} />,
//                   }}
//                   sx={{ mb: 2.5 }}
//                 />

//                 <TextField
//                   fullWidth
//                   label="Email Address"
//                   value={email}
//                   onChange={handleEmailChange}
//                   type="email"
//                   InputProps={{
//                     startAdornment: <Email sx={{ mr: 1, color: 'action.active' }} />,
//                   }}
//                   sx={{ mb: 2.5 }}
//                 />

//                 <TextField
//                   fullWidth
//                   label="Phone Number"
//                   value={phone}
//                   onChange={handlePhoneChange}
//                   InputProps={{
//                     startAdornment: <Phone sx={{ mr: 1, color: 'action.active' }} />,
//                   }}
//                   sx={{ mb: 2.5 }}
//                 />
//               </CardContent>
//             </Card>

//             {/* Role Selection */}
//             <Card sx={{ mb: 3, borderRadius: 3 }}>
//               <CardContent>
//                 <Typography
//                   variant="h6"
//                   sx={{
//                     mb: 3,
//                     color: mode === 'dark' ? '#fff' : '#333',
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: 1,
//                   }}
//                 >
//                   <Badge sx={{ color: '#102dff' }} />
//                   Role Selection
//                 </Typography>

//                 <FormControl fullWidth>
//                   <InputLabel>Select Role</InputLabel>
//                   <Select
//                     value={Role}
//                     onChange={onRoleChange}
//                     label="Select Role"
//                     sx={{ textAlign: 'left' }}
//                     MenuProps={{
//                       PaperProps: {
//                         sx: {
//                           borderRadius: 2,
//                           mt: 1,
//                         },
//                       },
//                     }}
//                   >
//                     {roledata.map((role) => (
//                       <MenuItem
//                         key={role.id}
//                         value={role.name}
//                         sx={{
//                           py: 1.5,
//                           px: 2,
//                           display: 'flex',
//                           alignItems: 'center',
//                           gap: 2,
//                           '&:hover': {
//                             backgroundColor: mode === 'dark' ? 'rgba(16, 45, 255, 0.1)' : '#f5f5f5',
//                           },
//                         }}
//                       >
//                         <Typography sx={{ fontSize: '1.2rem' }}>{role.icon}</Typography>
//                         <Typography>{role.name}</Typography>
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </CardContent>
//             </Card>

//             {/* Requested Leads Limit Section */}
//             <Card sx={{ mb: 3, borderRadius: 3 }}>
//               <CardContent>
//                 <Typography
//                   variant="h6"
//                   sx={{
//                     mb: 3,
//                     color: mode === 'dark' ? '#fff' : '#333',
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: 1,
//                   }}
//                 >
//                   <Numbers sx={{ color: '#4caf50' }} />
//                   Leads Request Limit
//                   <Chip
//                     label="Sales Limit"
//                     size="small"
//                     color="primary"
//                     sx={{ ml: 1, height: 20, fontSize: '0.7rem' }}
//                   />
//                 </Typography>

//                 <Typography
//                   variant="body2"
//                   sx={{ mb: 2, color: mode === 'dark' ? '#aaa' : '#666' }}
//                 >
//                   Maximum number of leads this user can request from the data pool
//                 </Typography>

//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                   <TextField
//                     type="number"
//                     label="Leads Limit"
//                     value={requestedLeadsLimit}
//                     onChange={handleRequestedLeadsLimitChange}
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <Numbers sx={{ color: '#4caf50' }} />
//                         </InputAdornment>
//                       ),
//                       endAdornment: (
//                         <InputAdornment position="end">
//                           <Typography variant="caption" sx={{ color: '#666' }}>
//                             leads
//                           </Typography>
//                         </InputAdornment>
//                       ),
//                     }}
//                     sx={{ flex: 1 }}
//                   />
//                 </Box>

//                 {/* Slider for easy adjustment */}
//                 <Box sx={{ mt: 3, px: 1 }}>
//                   <Slider
//                     value={requestedLeadsLimit}
//                     onChange={(e, newValue) => setRequestedLeadsLimit(newValue)}
//                     min={0}
//                     max={1000}
//                     step={10}
//                     valueLabelDisplay="auto"
//                     valueLabelFormat={(value) => `${value} leads`}
//                     sx={{
//                       color: '#4caf50',
//                       '& .MuiSlider-valueLabel': {
//                         backgroundColor: '#4caf50',
//                       },
//                     }}
//                   />
//                   <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
//                     <Typography variant="caption" sx={{ color: mode === 'dark' ? '#aaa' : '#666' }}>
//                       0
//                     </Typography>
//                     <Typography variant="caption" sx={{ color: mode === 'dark' ? '#aaa' : '#666' }}>
//                       250
//                     </Typography>
//                     <Typography variant="caption" sx={{ color: mode === 'dark' ? '#aaa' : '#666' }}>
//                       500
//                     </Typography>
//                     <Typography variant="caption" sx={{ color: mode === 'dark' ? '#aaa' : '#666' }}>
//                       750
//                     </Typography>
//                     <Typography variant="caption" sx={{ color: mode === 'dark' ? '#aaa' : '#666' }}>
//                       1000
//                     </Typography>
//                   </Box>
//                 </Box>

//                 <Typography
//                   variant="caption"
//                   sx={{
//                     display: 'block',
//                     mt: 2,
//                     color: requestedLeadsLimit === 0 ? '#f44336' : '#4caf50',
//                     fontStyle: 'italic',
//                   }}
//                 >
//                   {requestedLeadsLimit === 0
//                     ? '⚠️ User cannot request any leads (limit is 0)'
//                     : `✅ User can request up to ${requestedLeadsLimit} leads total`}
//                 </Typography>
//               </CardContent>
//             </Card>

//             {/* Channels Selection (for Marketers) */}
//             {Role === 'Marketer' && (
//               <Card sx={{ mb: 3, borderRadius: 3 }}>
//                 <CardContent>
//                   <Typography
//                     variant="h6"
//                     sx={{
//                       mb: 3,
//                       color: mode === 'dark' ? '#fff' : '#333',
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: 1,
//                     }}
//                   >
//                     <Campaign sx={{ color: '#9c27b0' }} />
//                     Channel Assignment
//                     <Chip
//                       label="Required"
//                       size="small"
//                       color="error"
//                       sx={{ ml: 1, height: 20, fontSize: '0.7rem' }}
//                     />
//                   </Typography>

//                   {channelsLoading ? (
//                     <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
//                       <CircularProgress size={28} />
//                     </Box>
//                   ) : (
//                     <>
//                       <FormControl fullWidth>
//                         <InputLabel>Select Channels</InputLabel>
//                         <Select
//                           multiple
//                           value={selectedChannels}
//                           onChange={handleChannelChange}
//                           label="Select Channels"
//                           sx={{
//                             '& .MuiOutlinedInput-root': {
//                               borderRadius: 2,
//                             },
//                           }}
//                           renderValue={(selected) => (
//                             <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//                               {selected.map((channelId) => {
//                                 const channel = channels.find((c) => c._id === channelId);
//                                 return (
//                                   <Chip
//                                     key={channelId}
//                                     label={channel ? channel.name : 'Loading...'}
//                                     size="small"
//                                     onDelete={() => removeChannel(channelId)}
//                                     deleteIcon={<CloseIcon />}
//                                   />
//                                 );
//                               })}
//                             </Box>
//                           )}
//                           MenuProps={{
//                             PaperProps: {
//                               sx: {
//                                 borderRadius: 2,
//                                 mt: 1,
//                               },
//                             },
//                           }}
//                         >
//                           {channels && channels.length > 0 ? (
//                             channels.map((channel) => (
//                               <MenuItem
//                                 key={channel._id}
//                                 value={channel._id}
//                                 sx={{
//                                   py: 1.5,
//                                   '&.Mui-selected': {
//                                     backgroundColor:
//                                       mode === 'dark'
//                                         ? 'rgba(156, 39, 176, 0.2)'
//                                         : 'rgba(156, 39, 176, 0.1)',
//                                   },
//                                 }}
//                               >
//                                 <Box
//                                   sx={{
//                                     display: 'flex',
//                                     justifyContent: 'space-between',
//                                     width: '100%',
//                                   }}
//                                 >
//                                   <Typography>{channel.name}</Typography>
//                                   <Typography variant="caption" sx={{ color: '#666' }}>
//                                     {channel.code}
//                                   </Typography>
//                                 </Box>
//                               </MenuItem>
//                             ))
//                           ) : (
//                             <MenuItem disabled>
//                               <Typography sx={{ color: '#999', fontStyle: 'italic' }}>
//                                 No channels available
//                               </Typography>
//                             </MenuItem>
//                           )}
//                         </Select>
//                       </FormControl>

//                       {selectedChannels.length > 0 && (
//                         <Box sx={{ mt: 3 }}>
//                           <Typography
//                             variant="body2"
//                             sx={{ mb: 1, color: mode === 'dark' ? '#aaa' : '#666' }}
//                           >
//                             Selected Channels ({selectedChannels.length}):
//                           </Typography>
//                           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//                             {selectedChannels.map((channelId) => {
//                               const channel = channels.find((c) => c._id === channelId);
//                               return (
//                                 <Chip
//                                   key={channelId}
//                                   label={channel?.name || 'Unknown'}
//                                   onDelete={() => removeChannel(channelId)}
//                                   deleteIcon={<CloseIcon />}
//                                   color="primary"
//                                   variant="outlined"
//                                   sx={{
//                                     '& .MuiChip-label': {
//                                       fontWeight: 500,
//                                     },
//                                   }}
//                                 />
//                               );
//                             })}
//                           </Box>
//                         </Box>
//                       )}

//                       <Typography
//                         variant="caption"
//                         sx={{
//                           display: 'block',
//                           mt: 2,
//                           color:
//                             selectedChannels.length === 0
//                               ? '#f44336'
//                               : mode === 'dark'
//                                 ? '#4caf50'
//                                 : '#2e7d32',
//                           fontStyle: 'italic',
//                         }}
//                       >
//                         {selectedChannels.length === 0
//                           ? '⚠️ Please select at least one channel for Marketer'
//                           : `✅ ${selectedChannels.length} channel(s) selected`}
//                       </Typography>
//                     </>
//                   )}
//                 </CardContent>
//               </Card>
//             )}

//             {/* Permissions Section */}
//             <Accordion
//               expanded={expanded}
//               onChange={() => setExpanded(!expanded)}
//               sx={{
//                 mb: 3,
//                 borderRadius: '16px !important',
//                 overflow: 'hidden',
//                 '&:before': { display: 'none' },
//               }}
//             >
//               <AccordionSummary
//                 expandIcon={expanded ? <ExpandLess /> : <ExpandMore />}
//                 sx={{
//                   bgcolor: mode === 'dark' ? '#2d2d2d' : '#f8f9fa',
//                   borderRadius: expanded ? '16px 16px 0 0' : '16px',
//                 }}
//               >
//                 <Typography
//                   variant="h6"
//                   sx={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: 1,
//                   }}
//                 >
//                   <Comment sx={{ color: '#102dff' }} />
//                   User Permissions
//                 </Typography>
//               </AccordionSummary>

//               <AccordionDetails sx={{ bgcolor: mode === 'dark' ? '#252525' : '#fff' }}>
//                 {/* Open Comments Section */}
//                 <Box
//                   sx={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center',
//                     p: 2,
//                     mb: 2,
//                     borderRadius: 2,
//                     bgcolor:
//                       mode === 'dark' ? 'rgba(144, 202, 249, 0.05)' : 'rgba(33, 150, 243, 0.05)',
//                     border: `1px solid ${mode === 'dark' ? '#333' : '#e0e0e0'}`,
//                   }}
//                 >
//                   <Box>
//                     <Typography
//                       variant="subtitle1"
//                       sx={{ fontWeight: 'bold', color: mode === 'dark' ? '#fff' : '#333' }}
//                     >
//                       {openCommentsLabel.title}
//                     </Typography>
//                     <Typography
//                       variant="body2"
//                       sx={{ color: mode === 'dark' ? '#aaa' : '#666', mt: 0.5 }}
//                     >
//                       {openCommentsLabel.description}
//                     </Typography>
//                   </Box>
//                   <Switch checked={opencommentschecked} onChange={handleChange} color="primary" />
//                 </Box>

//                 {/* Close Done Deal Stage And EOI Stage */}
//                 {!isSpecialRole() && (
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       justifyContent: 'space-between',
//                       alignItems: 'center',
//                       p: 2,
//                       borderRadius: 2,
//                       bgcolor:
//                         mode === 'dark' ? 'rgba(76, 175, 80, 0.05)' : 'rgba(76, 175, 80, 0.05)',
//                       border: `1px solid ${mode === 'dark' ? '#333' : '#e0e0e0'}`,
//                     }}
//                   >
//                     <Box>
//                       <Typography
//                         variant="subtitle1"
//                         sx={{ fontWeight: 'bold', color: mode === 'dark' ? '#fff' : '#333' }}
//                       >
//                         Close Done Deal Stage And EOI Stage
//                       </Typography>
//                       <Typography
//                         variant="body2"
//                         sx={{ color: mode === 'dark' ? '#aaa' : '#666', mt: 0.5 }}
//                       >
//                         Allow user to show Done Deal or EOI Leads or not Allow
//                       </Typography>
//                     </Box>
//                     <Switch
//                       checked={CloseDoneDealcommentschecked}
//                       onChange={handleChangeCloseDoneDealComments}
//                       color="success"
//                     />
//                   </Box>
//                 )}

//                 {/* Status indicators */}
//                 <Box sx={{ mt: 3, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
//                   {opencommentschecked && (
//                     <Chip
//                       icon={<CheckCircle />}
//                       label={openCommentsLabel.title + " Enabled"}
//                       color="primary"
//                       variant="outlined"
//                       size="small"
//                     />
//                   )}
//                   {CloseDoneDealcommentschecked && !isSpecialRole() && (
//                     <Chip
//                       icon={<CheckCircle />}
//                       label="Closed Deals And EOI Enabled"
//                       color="success"
//                       variant="outlined"
//                       size="small"
//                     />
//                   )}
//                 </Box>
//               </AccordionDetails>
//             </Accordion>

//             {/* Submit Button */}
//             <Button
//               fullWidth
//               variant="contained"
//               type="submit"
//               disabled={updateLoading}
//               startIcon={updateLoading ? <CircularProgress size={20} /> : <Done />}
//               sx={{
//                 py: 1.5,
//                 borderRadius: 2,
//                 fontSize: '1rem',
//                 fontWeight: 'bold',
//                 textTransform: 'none',
//                 background: 'linear-gradient(135deg, #102dff 0%, #3f51b5 100%)',
//                 boxShadow: '0 4px 15px rgba(16, 45, 255, 0.2)',
//                 '&:hover': {
//                   background: 'linear-gradient(135deg, #0d25cc 0%, #303f9f 100%)',
//                   transform: 'translateY(-2px)',
//                   boxShadow: '0 6px 20px rgba(16, 45, 255, 0.3)',
//                 },
//                 '&:active': {
//                   transform: 'translateY(0)',
//                 },
//                 transition: 'all 0.3s ease',
//               }}
//             >
//               {updateLoading ? 'Updating User...' : 'Update User Profile'}
//             </Button>
//           </form>
//         </Paper>
//       </Container>
//     </Box>
//   );
// };




































// 20-5-2026
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { Get_One_user_data, Update_One_user_Main_data_Action } from '../Redux/Actions/AuthAction';
import { GetAllchannalData } from '../Redux/Actions/ChannalActions';
import { Notify } from '../Utility/Notify';
import { useSidebarWidth } from '../Utility/useSidebarWidth';

/* ─── Icons ──────────────────────────────────────────────────────────────── */
const IconPerson   = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
const IconMail     = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>;
const IconPhone    = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.16 6.16l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>;
const IconBadge    = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>;
const IconCamera   = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>;
const IconX        = () => <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IconChevron  = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 12 15 18 9"/></svg>;
const IconCheck    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>;
const IconNumbers  = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="4" y1="9" x2="20" y2="9"/><line x1="4" y1="15" x2="20" y2="15"/><line x1="10" y1="3" x2="8" y2="21"/><line x1="16" y1="3" x2="14" y2="21"/></svg>;
const IconChannel  = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"/></svg>;
const IconArrow    = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="9 18 15 12 9 6"/></svg>;
const IconSearch   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>;
const IconSync     = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>;
const IconShield   = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>;
const IconComment  = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>;
const IconChevronDown = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 12 15 18 9"/></svg>;

const ROLE_DATA = [
  { name: 'Admin',       icon: '👨‍💼', color: '#ef4444' },
  { name: 'Manager',     icon: '👔',  color: '#3b82f6' },
  { name: 'Sales',       icon: '💰',  color: '#22c55e' },
  { name: 'Team Leader', icon: '👥',  color: '#f59e0b' },
  { name: 'Marketer',    icon: '📢',  color: '#a855f7' },
  { name: 'Accountant',  icon: '📊',  color: '#64748b' },
];

/* ─── CSS ────────────────────────────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap');
  @keyframes eu-fade { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }
  @keyframes eu-spin  { to{transform:rotate(360deg)} }
  @keyframes eu-pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }
  .eu-card  { animation: eu-fade 0.3s ease both; }
  .eu-input {
    width:100%; padding:11px 14px 11px 40px; border-radius:10px; font-size:13px;
    font-family:'DM Sans',sans-serif; outline:none; box-sizing:border-box;
    transition:border-color 0.15s, box-shadow 0.15s;
  }
  .eu-input:focus { border-color:#1d4ed8 !important; box-shadow:0 0 0 3px rgba(29,78,216,0.1); }
  .eu-label { font-size:11px; font-weight:700; letter-spacing:0.07em; text-transform:uppercase; display:block; margin-bottom:7px; }
  .eu-chip {
    display:inline-flex; align-items:center; gap:5px; padding:4px 10px 4px 12px;
    border-radius:20px; font-size:12px; font-weight:600;
  }
  .eu-channel-opt {
    padding:10px 14px; font-size:13px; cursor:pointer; display:flex;
    align-items:center; justify-content:space-between;
    transition:background 0.1s; font-family:'DM Sans',sans-serif;
  }
  .eu-channel-opt:hover { background:rgba(168,85,247,0.06); }
  .eu-role-opt {
    padding:10px 14px; font-size:13px; cursor:pointer; display:flex;
    align-items:center; justify-content:space-between;
    transition:background 0.1s; font-family:'DM Sans',sans-serif;
  }
  .eu-role-opt:hover { background:rgba(29,78,216,0.06); }
  .eu-spin-el { width:16px;height:16px;border-radius:50%;border:2px solid rgba(255,255,255,0.35);border-top-color:#fff;animation:eu-spin 0.7s linear infinite;display:inline-block; }
  .eu-chan-scroll::-webkit-scrollbar { width:4px; }
  .eu-chan-scroll::-webkit-scrollbar-track { background:transparent; }
  .eu-chan-scroll::-webkit-scrollbar-thumb { background:rgba(168,85,247,0.3); border-radius:4px; }
  .eu-toggle { position:relative; display:inline-flex; align-items:center; cursor:pointer; }
  .eu-toggle input { opacity:0; width:0; height:0; position:absolute; }
  .eu-toggle-track {
    width:44px; height:24px; border-radius:12px; transition:background 0.2s;
    display:flex; align-items:center; padding:2px;
  }
  .eu-toggle-thumb {
    width:20px; height:20px; border-radius:50%; background:#fff;
    transition:transform 0.2s; box-shadow:0 1px 4px rgba(0,0,0,0.2);
  }
  .eu-section-header {
    display:flex; align-items:center; gap:10px; margin-bottom:18px;
  }
  .eu-section-icon {
    width:32px; height:32px; border-radius:9px;
    display:flex; align-items:center; justify-content:center; flex-shrink:0;
  }
`;

let cssInjected = false;
const injectCSS = () => {
  if (cssInjected) return; cssInjected = true;
  const el = document.createElement('style'); el.innerHTML = CSS; document.head.appendChild(el);
};

/* ─── Toggle Switch ──────────────────────────────────────────────────────── */
const Toggle = ({ checked, onChange, color = '#2563eb' }) => (
  <label className="eu-toggle">
    <input type="checkbox" checked={checked} onChange={onChange} />
    <div className="eu-toggle-track" style={{ background: checked ? color : '#d1d5db' }}>
      <div className="eu-toggle-thumb" style={{ transform: checked ? 'translateX(20px)' : 'translateX(0)' }} />
    </div>
  </label>
);

/* ─── Field ──────────────────────────────────────────────────────────────── */
const Field = ({ label, icon: Icon, children, C }) => (
  <div>
    <label className="eu-label" style={{ color: C.sub }}>{label}</label>
    <div style={{ position: 'relative' }}>
      <span style={{ position:'absolute', left:13, top:'50%', transform:'translateY(-50%)', color:C.sub, display:'flex', pointerEvents:'none' }}>
        <Icon />
      </span>
      {children}
    </div>
  </div>
);

/* ─── Section Header ─────────────────────────────────────────────────────── */
const SectionHeader = ({ icon: Icon, iconColor, title, C }) => (
  <div className="eu-section-header">
    <div className="eu-section-icon" style={{ background:`rgba(${iconColor},0.1)`, border:`1px solid rgba(${iconColor},0.2)`, color:`rgb(${iconColor})` }}>
      <Icon />
    </div>
    <span style={{ fontSize:14, fontWeight:700, color:C.text }}>{title}</span>
  </div>
);

/* ─── Main Component ─────────────────────────────────────────────────────── */
export const EditUserData = () => {
  injectCSS();
  const { id }       = useParams();
  const dispatch     = useDispatch();
  const theme        = useTheme();
  const isDark       = theme.palette.mode === 'dark';
  const sidebarWidth = useSidebarWidth();

  const [name,                    setName]                    = useState('');
  const [email,                   setEmail]                   = useState('');
  const [phone,                   setPhone]                   = useState('');
  const [role,                    setRole]                    = useState('');
  const [image,                   setImage]                   = useState('');
  const [selectedFile,            setSelectedFile]            = useState('');
  const [loading,                 setLoading]                 = useState(true);
  const [updateLoading,           setUpdateLoading]           = useState(false);
  const [dataReady,               setDataReady]               = useState(false);
  const [openComments,            setOpenComments]            = useState(false);
  const [closeDoneDeal,           setCloseDoneDeal]           = useState(false);
  const [requestedLeadsLimit,     setRequestedLeadsLimit]     = useState(100);
  const [selectedChannels,        setSelectedChannels]        = useState([]);
  const [channels,                setChannels]                = useState([]);
  const [channelsLoading,         setChannelsLoading]         = useState(false);
  const [focused,                 setFocused]                 = useState(null);
  const [roleOpen,                setRoleOpen]                = useState(false);
  const [chanOpen,                setChanOpen]                = useState(false);
  const [chanSearch,              setChanSearch]              = useState('');
  const [permissionsOpen,         setPermissionsOpen]         = useState(false);

  const resUserData    = useSelector((s) => s.AuthRoot.get_one_user_array);
  const resuserupdated = useSelector((s) => s.AuthRoot.oneuser);
  const resgetallchan  = useSelector((s) => s.AllChannalRoot?.channal);

  const C = {
    bg:      isDark ? '#0f1117' : '#f4f6f9',
    card:    isDark ? '#1a1f2e' : '#ffffff',
    border:  isDark ? '#252d45' : '#e8edf5',
    text:    isDark ? '#f1f5f9' : '#0d1b3e',
    sub:     isDark ? '#6b7280' : '#94a3b8',
    inputBg: isDark ? '#131929' : '#f8fafc',
    inBdr:   isDark ? '#252d45' : '#e2e8f0',
  };

  const inputStyle = (name) => ({
    border: `1.5px solid ${focused===name ? '#1d4ed8' : C.inBdr}`,
    background: C.inputBg, color: C.text,
    boxShadow: focused===name ? '0 0 0 3px rgba(29,78,216,0.1)' : 'none',
  });

  /* fetch user + channels */
  useEffect(() => {
    dispatch(Get_One_user_data(id));
  }, [dispatch, id]);

  const fetchChannels = async () => {
    setChannelsLoading(true);
    await dispatch(GetAllchannalData());
    setChannelsLoading(false);
  };

  useEffect(() => {
    if (resUserData?.data) {
      const u = resUserData.data;
      setName(u.name || '');
      setEmail(u.email || '');
      setPhone(u.phone || '');
      setRole(u.role || '');
      setImage(u.profileImg || '');
      setOpenComments(u.opencomments === true || u.opencomments === 'true');
      setCloseDoneDeal(u.CloseDoneDealcomments === true || u.CloseDoneDealcomments === 'true');
      setRequestedLeadsLimit(u.requestedleadslimit !== undefined ? u.requestedleadslimit : 100);
      if (u.role === 'Marketer' && u.channels) {
        setSelectedChannels(u.channels.map(ch => ch._id || ch));
        fetchChannels();
      }
      setDataReady(true);
    }
  }, [resUserData]);

  useEffect(() => { if (resgetallchan?.data) setChannels(resgetallchan.data); }, [resgetallchan]);

  /* close dropdowns outside click */
  useEffect(() => {
    const handler = (e) => {
      if (!e.target.closest('.eu-role-wrap')) setRoleOpen(false);
      if (!e.target.closest('.eu-chan-wrap'))  { setChanOpen(false); setChanSearch(''); }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  useEffect(() => {
    if (loading === false) {
      if (resuserupdated?.status === 200) {
        Notify('success', 'Updated successfully', 'success');
        setTimeout(() => { window.location.href = '#/Users'; }, 1500);
      }
    }
  }, [loading, resuserupdated]);

  const handleRole = (roleName) => {
    if ((role === 'Marketer' && roleName !== 'Marketer') ||
        (role !== 'Marketer' && roleName === 'Marketer')) {
      setSelectedChannels([]);
    }
    setRole(roleName);
    setRoleOpen(false);
    if (roleName === 'Marketer' && channels.length === 0) fetchChannels();
  };

  const toggleChannel = (id) => setSelectedChannels(p => p.includes(id) ? p.filter(x=>x!==id) : [...p, id]);
  const selectAllChannels   = () => setSelectedChannels(channels.map(c => c._id));
  const deselectAllChannels = () => setSelectedChannels([]);

  const handleImageChange = (e) => {
    if (e.target.files?.[0]) {
      setImage(URL.createObjectURL(e.target.files[0]));
      setSelectedFile(e.target.files[0]);
    }
  };

  const validate = () => {
    if (!name.trim())  { Notify('error','Name is required','error');  return false; }
    if (!email.trim()) { Notify('error','Email is required','error'); return false; }
    if (!phone.trim()) { Notify('error','Phone is required','error'); return false; }
    if (!role)         { Notify('error','Role is required','error');  return false; }
    if (role === 'Marketer' && selectedChannels.length === 0) {
      Notify('error','At least one channel required','error'); return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    if (!validate()) return;
    setLoading(true);
    setUpdateLoading(true);
    const payload = {
      name, email, phone, role,
      opencomments: openComments,
      CloseDoneDealcomments: closeDoneDeal,
      requestedleadslimit: requestedLeadsLimit,
    };
    if (role === 'Marketer' && selectedChannels.length > 0) payload.channels = selectedChannels;
    await dispatch(Update_One_user_Main_data_Action(id, payload));
    setLoading(false);
    setUpdateLoading(false);
  };

  const isSpecialRole    = () => ['Sales','Team Leader','Manager'].includes(role);
  const isAdminMarketer  = () => ['Admin','Marketer'].includes(role);
  const selectedRoleData = ROLE_DATA.find(r => r.name === role);

  const openCommentsLabel = isSpecialRole()
    ? { title: 'Close Follow Up & Follow After Meeting', desc: 'Allow user to manage Follow Up and Follow After Meeting stages' }
    : isAdminMarketer()
    ? { title: 'Close Meeting, Follow After Meeting & Interested', desc: 'Allow user to manage these specific pipeline stages' }
    : { title: 'Open Comments', desc: 'Allow user to post comments on open deals' };

  const filteredChannels = channels.filter(ch => {
    const n = ch.name || '';
    return n.toLowerCase().includes(chanSearch.toLowerCase());
  });

  /* skeleton */
  const Skeleton = ({ w = '100%', h = 46 }) => (
    <div style={{ width:w, height:h, borderRadius:10, background:isDark?'rgba(255,255,255,0.04)':'rgba(0,0,0,0.04)', animation:'eu-pulse 1.4s ease-in-out infinite' }} />
  );

  return (
    <div style={{ position:'fixed', top:50, left:sidebarWidth, right:0, bottom:0, transition:'left 0.25s cubic-bezier(0.4,0,0.2,1)', overflowY:'auto', background:C.bg, fontFamily:"'DM Sans','Segoe UI',sans-serif" }}>

      {/* ── Breadcrumb ── */}
      <div style={{ padding:'12px 32px', background:isDark?'#141929':C.bg, borderBottom:`1px solid ${C.border}`, display:'flex', alignItems:'center', gap:8, fontSize:12 }}>
        <Link to="/AllLeadsForAdmin" style={{ textDecoration:'none', color:C.sub, fontWeight:500 }}>Home</Link>
        <span style={{ color:C.sub, display:'flex' }}><IconArrow /></span>
        <Link to="/Users" style={{ textDecoration:'none', color:C.sub, fontWeight:500 }}>Users</Link>
        <span style={{ color:C.sub, display:'flex' }}><IconArrow /></span>
        <span style={{ color:C.text, fontWeight:600 }}>Edit User</span>
      </div>

      <div style={{ padding:'32px', maxWidth:780 }}>

        {/* Page Title */}
        <div style={{ marginBottom:28 }}>
          <div style={{ fontSize:11, fontWeight:700, letterSpacing:'0.1em', textTransform:'uppercase', color:C.sub, marginBottom:4 }}>USER MANAGEMENT</div>
          <h1 style={{ fontSize:24, fontWeight:800, color:C.text, margin:0, letterSpacing:'-0.4px' }}>Edit User Profile</h1>
          <p style={{ fontSize:13, color:C.sub, margin:'6px 0 0' }}>Update user information, role, permissions and channel assignments.</p>
        </div>

        {/* ── Main Card ── */}
        <div className="eu-card" style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:20, boxShadow:isDark?'none':'0 4px 24px rgba(0,0,0,0.07)' }}>

          {/* ════ Profile Photo ════ */}
          <div style={{ padding:'24px 28px', borderBottom:`1px solid ${C.border}`, borderRadius:'20px 20px 0 0', overflow:'hidden' }}>
            <SectionHeader icon={IconCamera} iconColor="29,78,216" title="Profile Photo" C={C} />
            <div style={{ display:'flex', alignItems:'center', gap:20 }}>
              <div style={{ position:'relative', flexShrink:0 }}>
                <div style={{ width:80, height:80, borderRadius:16, background:image?'transparent':(isDark?'#252d45':'#f0f4ff'), border:`2px solid ${selectedRoleData?.color || C.border}`, overflow:'hidden', display:'flex', alignItems:'center', justifyContent:'center', color:C.sub, transition:'border-color 0.2s' }}>
                  {image
                    ? <img src={image} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                    : <span style={{ fontSize:28 }}>{selectedRoleData?.icon || '👤'}</span>}
                </div>
                <label htmlFor="eu-avatar" style={{ position:'absolute', bottom:-4, right:-4, width:24, height:24, borderRadius:8, background:'#1d4ed8', border:`2px solid ${C.card}`, display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', color:'#fff' }}>
                  <IconCamera />
                  <input id="eu-avatar" type="file" accept="image/*" style={{ display:'none' }} onChange={handleImageChange} />
                </label>
              </div>
              <div style={{ flex:1 }}>
                {selectedRoleData && (
                  <span style={{ display:'inline-flex', alignItems:'center', gap:6, padding:'3px 10px', borderRadius:20, fontSize:12, fontWeight:700, marginBottom:8, background:`${selectedRoleData.color}18`, color:selectedRoleData.color, border:`1px solid ${selectedRoleData.color}30` }}>
                    {selectedRoleData.icon} {selectedRoleData.name}
                  </span>
                )}
                <div style={{ fontSize:14, fontWeight:700, color:C.text, marginBottom:4 }}>{name || 'User Name'}</div>
                <div style={{ fontSize:12, color:C.sub, marginBottom:10 }}>Click avatar to change photo. JPG or PNG, max 5MB.</div>
                <div style={{ display:'flex', gap:10 }}>
                  <label htmlFor="eu-avatar2" style={{ fontSize:12, fontWeight:700, color:'#1d4ed8', cursor:'pointer', textDecoration:'underline' }}>
                    {image ? 'Change Photo' : 'Upload Photo'}
                    <input id="eu-avatar2" type="file" accept="image/*" style={{ display:'none' }} onChange={handleImageChange} />
                  </label>
                  {image && <button onClick={() => { setImage(''); setSelectedFile(''); }} style={{ fontSize:12, fontWeight:700, color:'#ef4444', background:'none', border:'none', cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>Remove</button>}
                </div>
              </div>
            </div>
          </div>

          {/* ════ Personal Information ════ */}
          <div style={{ padding:'24px 28px', borderBottom:`1px solid ${C.border}` }}>
            <SectionHeader icon={IconPerson} iconColor="29,78,216" title="Personal Information" C={C} />
            {!dataReady ? (
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'16px 20px' }}>
                {[1,2,3,4].map(i => <Skeleton key={i} />)}
              </div>
            ) : (
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'16px 20px' }}>
                <Field label="Full Name" icon={IconPerson} C={C}>
                  <input className="eu-input" placeholder="Full name" value={name} onChange={e => setName(e.target.value)}
                    onFocus={() => setFocused('name')} onBlur={() => setFocused(null)} style={inputStyle('name')} />
                </Field>
                <Field label="Email Address" icon={IconMail} C={C}>
                  <input className="eu-input" type="email" placeholder="email@company.com" value={email} onChange={e => setEmail(e.target.value)}
                    onFocus={() => setFocused('email')} onBlur={() => setFocused(null)} style={inputStyle('email')} />
                </Field>
                <Field label="Phone Number" icon={IconPhone} C={C}>
                  <input className="eu-input" placeholder="+1 (555) 000-0000" value={phone} onChange={e => setPhone(e.target.value)}
                    onFocus={() => setFocused('phone')} onBlur={() => setFocused(null)} style={inputStyle('phone')} />
                </Field>

                {/* Role Select */}
                <div className="eu-role-wrap" style={{ position:'relative' }}>
                  <label className="eu-label" style={{ color:C.sub }}>Job Role</label>
                  <div style={{ position:'relative' }}>
                    <span style={{ position:'absolute', left:13, top:'50%', transform:'translateY(-50%)', color:C.sub, display:'flex', pointerEvents:'none', zIndex:1 }}><IconBadge /></span>
                    <div onClick={() => setRoleOpen(o=>!o)} style={{ ...inputStyle('role'), padding:'11px 36px 11px 40px', borderRadius:10, border:`1.5px solid ${roleOpen?'#1d4ed8':C.inBdr}`, background:C.inputBg, color:role?C.text:C.sub, fontSize:13, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'space-between', userSelect:'none', boxShadow:roleOpen?'0 0 0 3px rgba(29,78,216,0.1)':'none' }}>
                      {selectedRoleData
                        ? <span style={{ display:'flex', alignItems:'center', gap:8 }}><span>{selectedRoleData.icon}</span><span style={{ fontWeight:600 }}>{selectedRoleData.name}</span></span>
                        : 'Select role…'}
                      <span style={{ display:'flex', color:C.sub, transform:roleOpen?'rotate(180deg)':'none', transition:'transform 0.2s' }}><IconChevron /></span>
                    </div>
                    {roleOpen && (
                      <div style={{ position:'absolute', top:'calc(100% + 6px)', left:0, right:0, zIndex:9999, background:isDark?'#1e2132':'#fff', border:`1px solid ${C.border}`, borderRadius:12, overflow:'hidden', boxShadow:isDark?'0 16px 40px rgba(0,0,0,0.5)':'0 8px 32px rgba(0,0,0,0.12)' }}>
                        {ROLE_DATA.map(r => (
                          <div key={r.name} className="eu-role-opt" style={{ background:role===r.name?(isDark?'rgba(29,78,216,0.12)':'rgba(29,78,216,0.06)'):'transparent', color:role===r.name?'#1d4ed8':C.text }} onClick={() => handleRole(r.name)}>
                            <span style={{ display:'flex', alignItems:'center', gap:10 }}><span style={{ fontSize:16 }}>{r.icon}</span><span style={{ fontWeight:600 }}>{r.name}</span></span>
                            {role===r.name && <span style={{ color:'#1d4ed8', display:'flex' }}><IconCheck /></span>}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* ════ Leads Limit ════ */}
          <div style={{ padding:'24px 28px', borderBottom:`1px solid ${C.border}` }}>
            <SectionHeader icon={IconNumbers} iconColor="34,197,94" title="Leads Request Limit" C={C} />
            <div style={{ padding:'18px 20px', borderRadius:12, background:isDark?'rgba(34,197,94,0.05)':'rgba(34,197,94,0.04)', border:`1px solid ${isDark?'rgba(34,197,94,0.2)':'rgba(34,197,94,0.15)'}` }}>
              <p style={{ fontSize:12, color:C.sub, margin:'0 0 16px' }}>Maximum number of leads this user can request from the data pool.</p>
              <div style={{ display:'flex', alignItems:'center', gap:14, marginBottom:16 }}>
                <div style={{ position:'relative', width:180 }}>
                  <span style={{ position:'absolute', left:12, top:'50%', transform:'translateY(-50%)', color:'#22c55e', display:'flex', pointerEvents:'none' }}><IconNumbers /></span>
                  <input type="number" value={requestedLeadsLimit}
                    onChange={(e) => { const v=parseInt(e.target.value); if(!isNaN(v)&&v>=0) setRequestedLeadsLimit(v); }}
                    onFocus={() => setFocused('leads')} onBlur={() => setFocused(null)}
                    style={{ width:'100%', padding:'10px 14px 10px 36px', borderRadius:9, border:`1.5px solid ${focused==='leads'?'#22c55e':C.inBdr}`, background:C.inputBg, color:C.text, fontSize:13, fontFamily:"'DM Sans',sans-serif", outline:'none', boxSizing:'border-box', boxShadow:focused==='leads'?'0 0 0 3px rgba(34,197,94,0.1)':'none' }} />
                </div>
                <span style={{ fontSize:12, color:C.sub }}>leads maximum</span>
              </div>
              <input type="range" min={0} max={1000} step={10} value={requestedLeadsLimit}
                onChange={(e) => setRequestedLeadsLimit(Number(e.target.value))}
                style={{ width:'100%', accentColor:'#22c55e', cursor:'pointer' }} />
              <div style={{ display:'flex', justifyContent:'space-between', fontSize:11, color:C.sub, marginTop:4 }}>
                {['0','250','500','750','1000'].map(v => <span key={v}>{v}</span>)}
              </div>
              <div style={{ marginTop:12, fontSize:12, fontStyle:'italic', color:requestedLeadsLimit===0?'#ef4444':'#22c55e' }}>
                {requestedLeadsLimit===0 ? '⚠️ User cannot request any leads' : `✅ User can request up to ${requestedLeadsLimit} leads`}
              </div>
            </div>
          </div>

          {/* ════ Channels (Marketer only) ════ */}
          {role === 'Marketer' && (
            <div style={{ padding:'24px 28px', borderBottom:`1px solid ${C.border}` }}>
              <SectionHeader icon={IconChannel} iconColor="168,85,247" title="Assign Channels" C={C} />
              <div style={{ padding:'16px 18px', borderRadius:12, background:isDark?'rgba(168,85,247,0.05)':'rgba(168,85,247,0.04)', border:`1px solid ${isDark?'rgba(168,85,247,0.2)':'rgba(168,85,247,0.15)'}` }}>

                {/* Selected chips */}
                {selectedChannels.length > 0 && (
                  <div style={{ display:'flex', flexWrap:'wrap', gap:7, marginBottom:14 }}>
                    {selectedChannels.map(chId => {
                      const ch = channels.find(c => c._id === chId);
                      return (
                        <span key={chId} className="eu-chip" style={{ background:isDark?'rgba(168,85,247,0.15)':'rgba(168,85,247,0.1)', color:'#a855f7', border:'1px solid rgba(168,85,247,0.25)' }}>
                          {ch?.name || 'Loading…'}
                          <button onClick={() => toggleChannel(chId)} style={{ background:'none', border:'none', cursor:'pointer', color:'#a855f7', display:'flex', padding:0 }}><IconX /></button>
                        </span>
                      );
                    })}
                  </div>
                )}

                {/* Dropdown */}
                <div className="eu-chan-wrap" style={{ position:'relative' }}>
                  <div onClick={() => { setChanOpen(o=>!o); setChanSearch(''); }} style={{ padding:'11px 40px 11px 14px', borderRadius:10, border:`1.5px solid ${chanOpen?'#a855f7':C.inBdr}`, background:C.inputBg, color:selectedChannels.length>0?'#a855f7':C.sub, fontSize:13, fontWeight:selectedChannels.length>0?600:400, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'space-between', userSelect:'none', position:'relative', boxShadow:chanOpen?'0 0 0 3px rgba(168,85,247,0.1)':'none', transition:'all 0.15s' }}>
                    <span>{selectedChannels.length > 0 ? `${selectedChannels.length} channel(s) selected` : 'Choose channels…'}</span>
                    <span style={{ display:'flex', color:C.sub, transform:chanOpen?'rotate(180deg)':'none', transition:'transform 0.2s', position:'absolute', right:14 }}><IconChevron /></span>
                  </div>

                  {chanOpen && (
                    <div style={{ position:'absolute', top:'calc(100% + 6px)', left:0, right:0, zIndex:99999, background:isDark?'#1e2132':'#fff', border:`1px solid ${isDark?'#2a2f45':'#e2e8f0'}`, borderRadius:14, overflow:'hidden', boxShadow:isDark?'0 20px 50px rgba(0,0,0,0.6)':'0 12px 40px rgba(0,0,0,0.15)' }}>
                      {/* Search */}
                      <div style={{ padding:'10px 12px', borderBottom:`1px solid ${isDark?'#2a2f45':'#f1f3f8'}`, position:'relative' }}>
                        <span style={{ position:'absolute', left:22, top:'50%', transform:'translateY(-50%)', color:C.sub, display:'flex', pointerEvents:'none' }}><IconSearch /></span>
                        <input autoFocus placeholder="Search channels…" value={chanSearch} onChange={e => setChanSearch(e.target.value)}
                          style={{ width:'100%', padding:'8px 12px 8px 34px', borderRadius:8, border:`1px solid ${isDark?'#2a2f45':'#e2e8f0'}`, background:isDark?'#151827':'#f8fafc', color:C.text, fontSize:13, fontFamily:"'DM Sans',sans-serif", outline:'none', boxSizing:'border-box' }} />
                      </div>
                      {/* Select/Deselect all */}
                      <div style={{ padding:'8px 12px', borderBottom:`1px solid ${isDark?'#2a2f45':'#f1f3f8'}`, display:'flex', gap:8 }}>
                        <button onClick={selectAllChannels} style={{ flex:1, padding:'7px', borderRadius:8, border:'none', cursor:'pointer', fontSize:12, fontWeight:700, fontFamily:"'DM Sans',sans-serif", background:isDark?'rgba(168,85,247,0.15)':'rgba(168,85,247,0.08)', color:'#a855f7', display:'flex', alignItems:'center', justifyContent:'center', gap:5 }}
                          onMouseEnter={e => e.currentTarget.style.background=isDark?'rgba(168,85,247,0.25)':'rgba(168,85,247,0.15)'}
                          onMouseLeave={e => e.currentTarget.style.background=isDark?'rgba(168,85,247,0.15)':'rgba(168,85,247,0.08)'}>
                          <IconCheck /> Select All ({channels.length})
                        </button>
                        <button onClick={deselectAllChannels} style={{ flex:1, padding:'7px', borderRadius:8, border:`1px solid ${isDark?'#2a2f45':'#e2e8f0'}`, cursor:'pointer', fontSize:12, fontWeight:700, fontFamily:"'DM Sans',sans-serif", background:'transparent', color:C.sub, display:'flex', alignItems:'center', justifyContent:'center', gap:5 }}
                          onMouseEnter={e => e.currentTarget.style.background=isDark?'rgba(255,255,255,0.06)':'#f1f5f9'}
                          onMouseLeave={e => e.currentTarget.style.background='transparent'}>
                          <IconX /> Deselect All
                        </button>
                      </div>
                      {/* Options */}
                      <div className="eu-chan-scroll" style={{ maxHeight:220, overflowY:'auto' }}>
                        {channelsLoading ? (
                          <div style={{ padding:18, textAlign:'center', color:C.sub, fontSize:13 }}>
                            <div style={{ width:20, height:20, borderRadius:'50%', border:`2px solid ${isDark?'#2a2f45':'#e2e8f0'}`, borderTopColor:'#a855f7', animation:'eu-spin 0.7s linear infinite', margin:'0 auto 8px' }} />
                            Loading channels…
                          </div>
                        ) : filteredChannels.length === 0 ? (
                          <div style={{ padding:14, textAlign:'center', color:C.sub, fontSize:13 }}>
                            {chanSearch ? `No channels match "${chanSearch}"` : 'No channels available'}
                          </div>
                        ) : filteredChannels.map(ch => {
                          const sel = selectedChannels.includes(ch._id);
                          return (
                            <div key={ch._id} className="eu-channel-opt" style={{ background:sel?(isDark?'rgba(168,85,247,0.12)':'rgba(168,85,247,0.06)'):'transparent', color:sel?'#a855f7':C.text }} onClick={() => toggleChannel(ch._id)}>
                              <span style={{ fontWeight:sel?700:500 }}>{ch.name}</span>
                              {ch.code && <span style={{ fontSize:11, color:C.sub, marginRight:'auto', marginLeft:8 }}>{ch.code}</span>}
                              {sel && <span style={{ color:'#a855f7', display:'flex' }}><IconCheck /></span>}
                            </div>
                          );
                        })}
                      </div>
                      {/* Footer */}
                      <div style={{ padding:'8px 14px', borderTop:`1px solid ${isDark?'#2a2f45':'#f1f3f8'}`, display:'flex', justifyContent:'space-between' }}>
                        <span style={{ fontSize:11, color:C.sub }}>{filteredChannels.length} result{filteredChannels.length!==1?'s':''}{chanSearch&&` for "${chanSearch}"`}</span>
                        <span style={{ fontSize:11, fontWeight:700, color:'#a855f7' }}>{selectedChannels.length} / {channels.length} selected</span>
                      </div>
                    </div>
                  )}
                </div>

                <div style={{ marginTop:10, fontSize:12, fontStyle:'italic', color:selectedChannels.length===0?'#ef4444':'#a855f7' }}>
                  {selectedChannels.length===0 ? '⚠️ Please select at least one channel' : `✅ ${selectedChannels.length} channel(s) assigned`}
                </div>
              </div>
            </div>
          )}

          {/* ════ Permissions ════ */}
          <div style={{ borderBottom:`1px solid ${C.border}` }}>
            {/* Accordion Header */}
            <div onClick={() => setPermissionsOpen(o=>!o)} style={{ padding:'18px 28px', display:'flex', alignItems:'center', justifyContent:'space-between', cursor:'pointer', userSelect:'none', background:isDark?'rgba(255,255,255,0.01)':'rgba(0,0,0,0.01)' }}>
              <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                <div className="eu-section-icon" style={{ background:'rgba(29,78,216,0.1)', border:'1px solid rgba(29,78,216,0.2)', color:'#1d4ed8' }}><IconShield /></div>
                <span style={{ fontSize:14, fontWeight:700, color:C.text }}>User Permissions</span>
                {(openComments || closeDoneDeal) && (
                  <span style={{ padding:'2px 8px', borderRadius:20, fontSize:11, fontWeight:700, background:'rgba(29,78,216,0.1)', color:'#1d4ed8' }}>
                    {[openComments, closeDoneDeal && !isSpecialRole()].filter(Boolean).length} active
                  </span>
                )}
              </div>
              <span style={{ display:'flex', color:C.sub, transform:permissionsOpen?'rotate(180deg)':'none', transition:'transform 0.2s' }}><IconChevronDown /></span>
            </div>

            {permissionsOpen && (
              <div style={{ padding:'0 28px 24px', display:'flex', flexDirection:'column', gap:12 }}>
                {/* Permission 1 */}
                <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'16px 18px', borderRadius:12, background:isDark?'rgba(29,78,216,0.05)':'rgba(29,78,216,0.03)', border:`1px solid ${isDark?'rgba(29,78,216,0.15)':'rgba(29,78,216,0.1)'}` }}>
                  <div style={{ flex:1, marginRight:16 }}>
                    <div style={{ fontSize:13, fontWeight:700, color:C.text, marginBottom:3, display:'flex', alignItems:'center', gap:6 }}>
                      <IconComment /> {openCommentsLabel.title}
                    </div>
                    <div style={{ fontSize:12, color:C.sub }}>{openCommentsLabel.desc}</div>
                  </div>
                  <Toggle checked={openComments} onChange={e => setOpenComments(e.target.checked)} color="#2563eb" />
                </div>

                {/* Permission 2 */}
                {!isSpecialRole() && (
                  <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'16px 18px', borderRadius:12, background:isDark?'rgba(34,197,94,0.05)':'rgba(34,197,94,0.03)', border:`1px solid ${isDark?'rgba(34,197,94,0.15)':'rgba(34,197,94,0.1)'}` }}>
                    <div style={{ flex:1, marginRight:16 }}>
                      <div style={{ fontSize:13, fontWeight:700, color:C.text, marginBottom:3, display:'flex', alignItems:'center', gap:6 }}>
                        <IconShield /> Close Done Deal Stage & EOI Stage
                      </div>
                      <div style={{ fontSize:12, color:C.sub }}>Allow user to view Done Deal or EOI leads</div>
                    </div>
                    <Toggle checked={closeDoneDeal} onChange={e => setCloseDoneDeal(e.target.checked)} color="#22c55e" />
                  </div>
                )}
              </div>
            )}
          </div>

          {/* ════ Footer Actions ════ */}
          <div style={{ padding:'18px 28px', display:'flex', alignItems:'center', justifyContent:'flex-end', gap:10, borderRadius:'0 0 20px 20px' }}>
            <Link to="/Users" style={{ textDecoration:'none' }}>
              <button style={{ padding:'11px 24px', borderRadius:10, border:'none', cursor:'pointer', fontSize:13, fontWeight:700, fontFamily:"'DM Sans',sans-serif", background:isDark?'rgba(255,255,255,0.07)':'#f1f5f9', color:isDark?'#d1d5db':'#374151', transition:'all 0.15s' }}
                onMouseEnter={e => e.currentTarget.style.background=isDark?'rgba(255,255,255,0.12)':'#e2e8f0'}
                onMouseLeave={e => e.currentTarget.style.background=isDark?'rgba(255,255,255,0.07)':'#f1f5f9'}>
                Cancel
              </button>
            </Link>
            <button onClick={handleSubmit} disabled={updateLoading||!dataReady}
              style={{ padding:'11px 28px', borderRadius:10, border:'none', cursor:(updateLoading||!dataReady)?'not-allowed':'pointer', fontSize:13, fontWeight:700, fontFamily:"'DM Sans',sans-serif", background:(updateLoading||!dataReady)?'rgba(245,158,11,0.5)':'linear-gradient(135deg,#0D47A1,#0D47A1)', color:'#fff', transition:'all 0.2s', boxShadow:(updateLoading||!dataReady)?'none':'0 4px 14px rgba(245,158,11,0.4)', display:'inline-flex', alignItems:'center', gap:8, opacity:(updateLoading||!dataReady)?0.75:1 }}
              onMouseEnter={e => { if(!updateLoading&&dataReady) e.currentTarget.style.transform='translateY(-1px)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform='translateY(0)'; }}>
              {updateLoading
                ? <><div className="eu-spin-el" />Updating…</>
                : <><IconSync /> Update User</>}
            </button>
          </div>

        </div>

        <footer style={{ marginTop:24, fontSize:11, color:isDark?'#374151':'#d1d5db', textAlign:'left' }}>
          © 2026 Realatix CRM. Smart CRM that connects customers, data, and sales in one safe place.
        </footer>
      </div>
    </div>
  );
};
